<template>
  <div>
    <div class="common__loading__2ISqR" style="user-select: none; display: none">
      <div class="common__loadingWarp__jRby5"><img src="https://www.8899851.com/oubo/static/image/loading-01298b545f5c991b77dcfde358b313f2.png" alt="loadingGif" style="width: 96px; height: 96px" /></div>
    </div>
    <div class="login__login_container__19JVq">
      <img src="https://www.8899851.com/oubo/static/image/bg.aeffce071a77b9f3cadbb3e35832d14b.jpg" width="100%" style="width: 100%; height: 100vh" /> <video id="login_video" autoplay preload loop class="login__video__3vENQ"><source src="https://www.8899851.com/oubo/static/image/video.mp4" type="video/mp4" /></video>
      <div class="login__login_box__2nAFl">
        <div class="login__contentBox__2Z4Z7 login__sp__3RBFD">
          <div data-analytics="button" data-label="登录-logo" class="login__logo__1NulW" style="margin-bottom: 23px">
            <a><img src="https://www.8899851.com/oubo/static/image/login_logo.0c8565183609c43ac8bf5dcbac9c6ce3.svg" width="310px" height="98px" /></a>
          </div>
          <div class="styles__sponsor__iVADu" style="margin-bottom: 28px">
            <div class="styles__title__2vzEr">赞助伙伴</div>
            <div class="styles__sponsorBox__ePs6n"><img src="https://www.8899851.com/oubo/static/image/zz_ob.dd3909f497e7ad7b077fddd9c608420a.png" height="44px" /></div>
          </div>
          <div>
            <input type="hidden" name="_token" value="pCza8bpM6H9LjlszCeE2Ylk1H3zEf0FGh5At3J0u" />
            <ul class="register__login_input__1kDu_">
              <li class="register__row__1yYHy">
                <div class="register__userWrap___s_S1">
                  <i class="register__icon__D7BhQ register__user__3jerM"></i>
                  <!-- onkeyup="value=value.replace(/[^0-9a-z]/ig,'')" -->
                  <input type="text" placeholder="帐号（最少6位，英文及数字）" readonly onfocus="this.removeAttribute('readonly');" onblur="this.setAttribute('readonly',true);" v-model="registerInfo.name" name="name" id="name" maxlength="32" value="" />
                </div>
              </li>
              <li class="register__row__1yYHy">
                <div class="register__userWrap___s_S1">
                  <div style="position: relative; display: inherit; width: 100%">
                    <i class="register__icon__D7BhQ register__password__2Yj9_"></i>
                    <!-- onkeyup="value=value.replace(/[^0-9a-zA-Z~!@#$%^&amp;*()_+,.?|:{}<>;=-]/ig, '')"  -->
                    <input :type="passShow ? 'password' : 'text'" v-model="registerInfo.password" placeholder="密码（最少8位，英文及数字）" name="password" id="password" maxlength="32" autocomplete="new-password2" value="" />
                    <div style="position: absolute; top: 13px; right: 12px; width: 16px; height: 16px; cursor: pointer" @click="changPassShow">
                      <img v-if="passShow" src="https://www.8899851.com/oubo/static/image/eye_close.0a2c8f5a5502b3cd6835e8c19be3bfbd.png" width="16px" height="16px" style="display: block" />
                      <img v-else src="https://www.8899851.com/oubo/static/image/eye_see.cfa834943719d71c121de1ebd3440954.png" width="16px" height="16px" style="display: block" />
                    </div>
                  </div>
                </div>
              </li>
              <li class="register__row__1yYHy">
                <div class="register__userWrap___s_S1">
                  <div style="position: relative; display: inherit; width: 100%">
                    <i class="register__icon__D7BhQ register__password__2Yj9_"></i>
                    <input v-model="registerInfo.confirmPass" :type="passShow1 ? 'password' : 'text'" placeholder="确认密码" id="repassword" name="secondPassword" maxlength="32" autocomplete="off" value="" />
                    <div style="position: absolute; top: 13px; right: 12px; width: 16px; height: 16px; cursor: pointer" @click="changPassShow1">
                      <img v-if="passShow1" src="https://www.8899851.com/oubo/static/image/eye_close.0a2c8f5a5502b3cd6835e8c19be3bfbd.png" width="16px" height="16px" style="display: block" />
                      <img v-else src="https://www.8899851.com/oubo/static/image/eye_see.cfa834943719d71c121de1ebd3440954.png" width="16px" height="16px" style="display: block" />
                    </div>
                  </div>
                </div>
              </li>
              <li class="register__row__1yYHy">
                <div class="register__userWrap___s_S1"><i class="register__icon__D7BhQ register__user__3jerM"></i> <input v-model="registerInfo.realname" type="text" placeholder="请输入您的真实姓名" name="realname" id="realname" maxlength="32" value="" /></div>
              </li>
              <li class="register__row__1yYHy">
                <div class="register__userWrap___s_S1">
                  <div style="position: relative; display: inherit; width: 100%">
                    <!-- onkeyup="value=value.replace(/[^0-9a-zA-Z~!@#$%^&amp;*()_+,.?|:{}<>;=-]/ig, '')" -->
                    <i class="register__icon__D7BhQ register__password__2Yj9_"></i>
                    <input v-model="registerInfo.paypassword" :type="passShow2 ? 'password' : 'text'" placeholder="请输入6位取款密码" id="qukuanmima" name="secondPassword" maxlength="6" autocomplete="off" value="" />
                    <div style="position: absolute; top: 13px; right: 12px; width: 16px; height: 16px; cursor: pointer" @click="changPassShow2">
                      <img v-if="passShow2" src="https://www.8899851.com/oubo/static/image/eye_close.0a2c8f5a5502b3cd6835e8c19be3bfbd.png" width="16px" height="16px" style="display: block" />
                      <img v-else src="https://www.8899851.com/oubo/static/image/eye_see.cfa834943719d71c121de1ebd3440954.png" width="16px" height="16px" style="display: block" />
                    </div>
                  </div>
                </div>
              </li>
              <li class="register__row__1yYHy">
                <div class="register__userWrap___s_S1">
                  <i class="register__icon__D7BhQ register__user__3jerM"></i> <input v-model="registerInfo.code" type="text" placeholder="验证码" maxlength="4" style="padding-right: 0" />
                  <img style="cursor: pointer; height: 37px; padding-top: 2px; padding-right: 8px" :src="`https://www.8899851.com/oubo/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
                </div>
              </li>

              <li class="register__row__1yYHy"></li>
              <li class="register__buttonBox__13Vic"><button data-analytics="button" type="button" @click="register" data-label="注册按钮点击次数" class="register__submit__1fyJo">注册</button></li>
              <div class="register__linkGroup__a4v25">
                <span data-label="登录提交" @click="$parent.goNav('/login')">已有账号？<span>请登录</span></span
                ><span data-label="登 录-先去逛逛" @click="$parent.goNav('/')">先去逛逛</span>
              </div>
            </ul>
            <div class="login__service__1lRgp">
              <div class="register__service__etg7Y" @click="$parent.openKefu"><img src="https://www.8899851.com/oubo/static/image/icon-online-service.6b73e5a37af863724b3a063314163f8a.svg" width="29px" class="register__serviceIcon__2PLa8" /><span style="cursor: pointer">联系客服</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register',
  data() {
    return {
      registerInfo: {},
      check_agree: true,
      passShow: true,
      passShow1: true,
      passShow2: true,
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      pid: '',

      index: 0,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  methods: {
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    changPassShow() {
      this.passShow = !this.passShow;
      console.log(1);
    },
    changPassShow1() {
      this.passShow1 = !this.passShow1;
    },
    changPassShow2() {
      this.passShow2 = !this.passShow2;
    },
    register() {
      let that = this;

      if (!that.check_agree) {
        that.$parent.showTost(0, '请阅读并同意相关条款和隐私协议！');
        return;
      }
      let info = {};
      info.name = that.registerInfo.name || '';
      info.password = that.registerInfo.password || '';
      info.confirmPass = that.registerInfo.confirmPass || '';
      info.realname = that.registerInfo.realname || '';
      info.paypassword = that.registerInfo.paypassword || '';
      let code = that.registerInfo.code || '';
      // 用户名验证
      let namereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/; //不得低于6位，以字母或数字组合！
      let passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/; //以字母或数字组合！不低于8位
      var realnamereg = /^[\u0391-\uFFE5a-zA-Z·&\\s]+$/; //中英文姓名
      let paypasswordreg = /^.{6,6}$/; //只能是6位
      let codereg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,}$/; //以字母或数字组合 不低于4位
      if (namereg.test(info.name) == false) {
        that.$parent.showTost(0, ' 用户名长度不得低于6位，以字母和数字组合！');
        return;
      }

      if (passwordreg.test(info.password) == false) {
        that.$parent.showTost(0, '密码长度最少8位！以字母和数字组合！');
        return;
      }
      if (info.confirmPass != info.password) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (realnamereg.test(info.realname) == false) {
        that.$parent.showTost(0, '姓名格式不正确，可以是中，英文名称！');
        return;
      }

      if (paypasswordreg.test(info.paypassword) == false) {
        that.$parent.showTost(0, '支付密码长度需是6位！');
        return;
      }
      if (codereg.test(code) == false || code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.registerInfo.code = '';
        that.changIndex();
        return;
      }
      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      that.$apiFun.register(info).then(res => {
        that.$parent.showTost(1, res.message);
        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);

          that.$store.commit('changToken');
          that.getUserInfo();
          that.$parent.openDaoTime();
        } else {
          that.registerInfo.code = null;
          that.changIndex();
          that.$parent.hideLoading();
        }
      });
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
          that.$router.push({ path: '/' });
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {},
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../static/css/registermember.css';
.login__login_box__2nAFl .login__contentBox__2Z4Z7.login__sp__3RBFD {
  padding-top: calc(50vh - 324px);
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue